import { render } from "./btc_withdraw.vue?vue&type=template&id=81f65f66&scoped=true"
import script from "./btc_withdraw.vue?vue&type=script&lang=js"
export * from "./btc_withdraw.vue?vue&type=script&lang=js"

import "./btc_withdraw.vue?vue&type=style&index=0&id=81f65f66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f65f66"]])

export default __exports__